import React from 'react';
export function EpisodeTileWall() {
  return <section className="relative py-16 md:py-32 overflow-hidden bg-eofa-black" data-id="element-31">
      <div className="container relative z-10 mx-auto px-6 md:px-6" data-id="element-32">
        {/* Section Intro */}
        <div className="max-w-[800px] text-center md:text-left" data-id="element-33">
          <span className="text-eofa-yellow tracking-[0.2em] text-[13px] uppercase font-bold mb-4 block" data-id="element-34">
            THE SHOW
          </span>
          <h2 className="text-eofa-white font-heading font-black text-[32px] md:text-[48px] lg:text-[64px] leading-[1.1] tracking-tighter mb-6" data-id="element-35">
            Unfiltered conversations with the people building Arizona.
          </h2>
          <p className="text-eofa-body text-lg max-w-[700px] leading-relaxed mx-auto md:mx-0" data-id="element-36">
            We sit down with local business owners from every walk of life. HVAC
            operators, Airbnb hosts, garage door pros, videographers, mobile
            detailers, drone experts, and more. We dig into who they are and
            what they're really doing to grow.
          </p>
        </div>
      </div>
    </section>;
}